import { LocalConf, SrvConf, } from 'httpConfig';
import Http from './http';

let httpUntil = new Http({ type: 'fetch', });

httpUntil.setOvertime(30 * 1000)
    .setCookieCors()
    .setHeader({
        Accept: 'application/json',
        invoke_source: SrvConf.invoke_source,
    }).setCookieCors();


export default {
    async setHeader({ key, val, }) {
        httpUntil.setHeader(key, val);
    },
    async getU(url, params = {}) {
        let res = await httpUntil.setUrl(LocalConf.baseURL + url)
            .setMethod('GET')
            .setBody(params)
            .setReturnType('json')
            .send()
            .then(data => data)
            .catch(error => {
                console.warn('=> catch: ', error);
            });
        return res;
    },
    async post(url, params = {}) {
        let res = await httpUntil.setBodyType('urlSearch')
            .setUrl(LocalConf.baseURL + url)
            .setMethod('POST')
            .setBody(params)
            .setReturnType('json')
            .send()
            .then(data => data)
            .catch(error => {
                console.warn('=> catch: ', error);
            });
        return res;
    },
    async upload(url, params = {}) {
        let res = await httpUntil
            // .setBodyType('urlSearch')
            .setBodyType('file')
            .setUrl(LocalConf.baseURL + url)
            .setMethod('POST')
            .setBody(params)
            .setReturnType('json')
            .send()
            .then(data => data)
            .catch(error => {
                console.warn('=> catch: ', error);
            });
        return res;
    },
    async download(url, params = {}) {
        let res = await httpUntil
            .setUrl(LocalConf.baseURL + url)
            .setMethod('POST')
            .setBody(params)
            .setReturnType('blob')
            .send()
            .then(data => data)
            .catch(error => {
                console.warn('=> catch: ', error);
            });
        return res;
    },
    async postJson(url, params = {}) {
        let res = await httpUntil.setBodyType('json')
            .setUrl(LocalConf.baseURL + url)
            .setMethod('POST')
            .setReturnType('json')
            .setBody(params)
            .send()
            .then(data => data)
            .catch(error => {
                console.warn('=> catch: ', error);
            });
        return res;
    },
};
